export interface BilletsBetweenCobblesRow {
	ProductionDate: string;
	Shift: string;
	Crew: string;
	ProductType: string;
	ProductSize: string | null;
	TotalBilletsCount: number;
	CobbleCount: number;
	BBC: number;
}

export interface BilletsBetweenCobblesPickerCrew {
	Id: string;
}

export interface BilletsBetweenCobblesPickerProductType {
	Id: number;
	Name: string;
}

export interface BilletsBetweenCobblesPickerReportType {
	Id: number;
	Name: string;
}

export interface BilletsBetweenCobblesPickers {
	crews: BilletsBetweenCobblesPickerCrew[];
	productTypes: BilletsBetweenCobblesPickerProductType[];
	reportTypes: BilletsBetweenCobblesPickerReportType[];
}

export const REPORT_TYPE_BY_SHIFT_SIZE = 1;
export const REPORT_TYPE_BY_SIZE = 2;

export const FALLBACK_REPORT_TYPES: BilletsBetweenCobblesPickerReportType[] = [
	{ Id: REPORT_TYPE_BY_SHIFT_SIZE, Name: "By Shift / Size" },
	{ Id: REPORT_TYPE_BY_SIZE, Name: "By Size" },
];

export type BilletsBetweenCobblesSortType =
	| "PRODUCTIONDATE-ASC"
	| "PRODUCTIONDATE-DESC"
	| "SHIFT-ASC"
	| "SHIFT-DESC"
	| "CREW-ASC"
	| "CREW-DESC"
	| "PRODUCTTYPE-ASC"
	| "PRODUCTTYPE-DESC"
	| "PRODUCTSIZE-ASC"
	| "PRODUCTSIZE-DESC"
	| "TOTALBILLETSCOUNT-ASC"
	| "TOTALBILLETSCOUNT-DESC"
	| "COBBLECOUNT-ASC"
	| "COBBLECOUNT-DESC"
	| "BBC-ASC"
	| "BBC-DESC";
